"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.describeETHPath = exports.ETHTransactionType = void 0;
const utils_1 = require("./utils");
var ETHTransactionType;
(function (ETHTransactionType) {
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_LEGACY"] = 0] = "ETH_TX_TYPE_LEGACY";
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_EIP_2930"] = 1] = "ETH_TX_TYPE_EIP_2930";
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_EIP_1559"] = 2] = "ETH_TX_TYPE_EIP_1559";
})(ETHTransactionType = exports.ETHTransactionType || (exports.ETHTransactionType = {}));
function describeETHPath(path) {
    let pathStr = utils_1.addressNListToBIP32(path);
    let unknown = {
        verbose: pathStr,
        coin: "Ethereum",
        isKnown: false,
    };
    if (path.length !== 5)
        return unknown;
    if (path[0] !== 0x80000000 + 44)
        return unknown;
    if (path[1] !== 0x80000000 + utils_1.slip44ByCoin("Ethereum"))
        return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000)
        return unknown;
    if (path[3] !== 0)
        return unknown;
    if (path[4] !== 0)
        return unknown;
    let index = path[2] & 0x7fffffff;
    return {
        verbose: `Ethereum Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Ethereum",
        isKnown: true,
        isPrefork: false,
    };
}
exports.describeETHPath = describeETHPath;
